import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import AlertBanner from "lib/components/alert/AlertBanner";
import AlertMessage from "lib/components/alert/AlertMessage";

import { asTitle } from "utils/Utils";
import useGet from "utils/fetch/useGet";

import OrganisationClient from "organisation/OrganisationClient";
import EditOrganisationGeneralForm from "./EditOrganisationGeneralForm";

export type OrganisationGeneralOverviewProps = {
	orgId: number;
};

export default function OrganisationGeneralOverview(
	props: Readonly<OrganisationGeneralOverviewProps>
) {
	const { t } = useTranslation();

	const { response } = useGet(OrganisationClient.get(props.orgId));

	return (
		<>
			<Typography variant="h1">{asTitle(t("organisation"))}</Typography>
			{response.state === "LOADING" && (
				<Box display="flex" justifyContent="center">
					<CircularProgress />
				</Box>
			)}

			{response.state === "ERROR" && (
				<AlertBanner
					alert={AlertMessage.error(t("loadOrganisationError"))}
				/>
			)}

			{response.state === "SUCCESS" && (
				<EditOrganisationGeneralForm
					id={props.orgId}
					name={response.data.name}
					slogan={response.data.slogan ?? ""}
					description={response.data.description ?? ""}
					type={response.data.type}
					smallLogo={response.data.smallLogo ?? ""}
					largeLogo={response.data.largeLogo ?? ""}
					vatIdentification={response.data.vatIdentification ?? ""}
					streetName={response.data.streetName}
					streetNumber={response.data.streetNumber}
					postalCode={response.data.postalCode}
					city={response.data.city}
					country={response.data.country}
					email={response.data.email}
					phoneNumber={response.data.phoneNumber}
				/>
			)}
		</>
	);
}
